import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgAudiusLogo = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M47.8489 43.2517L36.4235 23.427L31.0643 14.1334L24.9971 3.60883C24.8967 3.43496 24.7524 3.29057 24.5786 3.19018C24.4047 3.08979 24.2075 3.03694 24.0068 3.03694C23.806 3.03694 23.6088 3.08979 23.435 3.19018C23.2611 3.29057 23.1168 3.43496 23.0165 3.60883L11.5643 23.4123L6.88471 31.5044C6.78419 31.6783 6.73123 31.8757 6.73114 32.0765C6.73105 32.2774 6.78384 32.4748 6.88421 32.6488C6.98458 32.8228 7.12898 32.9673 7.30291 33.0678C7.47683 33.1683 7.67415 33.2213 7.87502 33.2213L16.715 33.2269C16.9157 33.2269 17.1129 33.1741 17.2869 33.074C17.4608 32.9738 17.6054 32.8297 17.7062 32.6561L22.3 24.7096L23.0026 23.4943C23.0303 23.4475 23.0612 23.4025 23.0948 23.3597C23.2105 23.2128 23.3605 23.0965 23.5316 23.021C23.7027 22.9454 23.8896 22.913 24.0762 22.9264C24.2627 22.9399 24.4431 22.9989 24.6015 23.0982C24.76 23.1975 24.8917 23.3342 24.9851 23.4962L29.7522 31.7654L30.6347 33.2933C30.6827 33.3779 30.7205 33.468 30.7471 33.5616C30.7937 33.7316 30.8004 33.9101 30.7667 34.0832C30.7329 34.2562 30.6596 34.4191 30.5525 34.5592C30.4454 34.6992 30.3073 34.8126 30.1492 34.8906C29.991 34.9685 29.817 35.0088 29.6407 35.0083L19.2415 35.0019C19.0407 35.0019 18.8435 35.0546 18.6696 35.1548C18.4956 35.2549 18.351 35.399 18.2502 35.5726L13.8243 43.2259C13.7237 43.3997 13.6707 43.5968 13.6705 43.7976C13.6704 43.9984 13.7231 44.1957 13.8234 44.3696C13.9237 44.5435 14.068 44.688 14.2418 44.7884C14.4157 44.8889 14.6129 44.9418 14.8137 44.9419L23.9782 44.9483L35.4055 44.9557L46.8558 44.9631C47.0562 44.9632 47.2532 44.9107 47.4269 44.8107C47.6006 44.7107 47.7449 44.5669 47.8455 44.3935C47.9461 44.2202 47.9994 44.0235 48 43.8231C48.0006 43.6227 47.9485 43.4256 47.8489 43.2517Z", fill: props.fill }));
});
export default SvgAudiusLogo;
